// Bounded, pure formatter cache. Timezone semantics and DST decisions are
// unchanged; constructing ICU formatters per source observation is expensive.
const formatters = new Map();
export function dateFormatter(locale, options) {
  const key = `${locale}:${JSON.stringify(options)}`;
  if (!formatters.has(key)) {
    if (formatters.size >= 32) formatters.delete(formatters.keys().next().value);
    formatters.set(key, new Intl.DateTimeFormat(locale, options));
  }
  return formatters.get(key);
}
